module.exports = __webpack_public_path__ + "static/img/63ca16ada777a5c20bcf94e94afcajpeg.e3a63ca.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/63ca16ada777a5c20bcf94e94afcajpeg.jpeg
// module id = 69
// module chunks = 2